import React from 'react';
import Icon from '../reusables/Icon';

type PoolPanelProps = {
    icon: string;
    shortName: string;
    description: string;
    calculationType: string;
    percentage: string;
    onEdit?: () => void;
    onDelete?: () => void;
};

const Panel: React.FC<PoolPanelProps> = ({
    icon,
    shortName,
    description,
    calculationType,
    percentage,
    onEdit,
    onDelete,
}) => {
    return (
        <div className="poolPanel">
            <div className="pool-panel-top">
                <div className="pool-panel-icon">
                    <Icon iconName={icon} />
                </div>
                <div>
                    <div className="pool-panel-title">{shortName}</div>
                    <div className="pool-panel-description">{description}</div>
                </div>
            </div>

            <div className="pool-panel-separator" />

            <div className="pool-panel-bottom">
                <div className="pool-panel-calculation">
                    <div className="calculation-text">
                        {calculationType}: {percentage}
                    </div>
                </div>
                <div className="pool-action-icons">
                    <Icon
                        onClick={onDelete}
                        iconName="Appkit4-icon icon-delete-outline"
                    />
                    <Icon
                        onClick={onEdit}
                        iconName="Appkit4-icon icon-edit-outline"
                    />
                </div>
            </div>
        </div>
    );
};

export default Panel;
